module.exports = __webpack_public_path__ + "img/clock.60bd53fb.svg";